import { render, staticRenderFns } from "./MiniaturesSection.vue?vue&type=template&id=eaccff32&scoped=true"
import script from "./MiniaturesSection.vue?vue&type=script&lang=js"
export * from "./MiniaturesSection.vue?vue&type=script&lang=js"
import style0 from "./MiniaturesSection.vue?vue&type=style&index=0&id=eaccff32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaccff32",
  null
  
)

export default component.exports